// frontend/src/components/LoginForm.jsx
import React, { useState } from "react";
import api from "../api";

export default function LoginForm({ onLogin }) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);

        try {
            const res = await api.post("/auth/login", { email, password });

            // бекенд тепер повертає: { user: { id, email, role }, token }
            const { user, token } = res.data || {};
            if (!user || !token) {
                throw new Error("Invalid auth response");
            }

            const { email: resEmail, role } = user;

            onLogin({ token, role, email: resEmail });
        } catch (err) {
            console.error("Login error:", err);
            setError(err.response?.data?.message || "Login error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full max-w-sm rounded-3xl border border-slate-200 bg-white/90 p-6 shadow-soft dark:border-slate-800 dark:bg-slate-900/90">
            <h2 className="mb-4 text-lg font-semibold text-slate-900 dark:text-slate-50 text-center">
                Log in (admin)
            </h2>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-300 mb-1">
                        Email
                    </label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-50"
                        required
                    />
                </div>

                <div>
                    <label className="block text-xs font-medium text-slate-600 dark:text-slate-300 mb-1">
                        Password
                    </label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm focus:border-slate-500 focus:outline-none focus:ring-1 focus:ring-slate-500 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-50"
                        required
                    />
                </div>

                {error && (
                    <p className="text-xs text-red-500">{error}</p>
                )}

                <button
                    type="submit"
                    disabled={loading}
                    className="w-full rounded-xl bg-slate-900 py-2 text-sm font-medium text-slate-50 shadow-sm hover:bg-black disabled:opacity-60 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-white transition-colors"
                >
                    {loading ? "Processing…" : "Log in"}
                </button>
            </form>

            {/* реєстрації більше немає, тому низ можна взагалі прибрати або залишити підказку */}
            <div className="mt-4 text-center">
                <p className="text-[11px] text-slate-500 dark:text-slate-400">
                    Access only for administrators.
                </p>
            </div>
        </div>
    );
}
